import React  from "react";
import { useNavigate } from "react-router-dom";
import "./Portfolio.css";
//import components
import Navbar from "../../Components/Navbar/Navbar";
import Footer from "../../Components/Footer/Footer";
import Partner from "./Partner";
import Footprint from "../../Components/Footprint/Footprint";
import BreadcrumbHead from "../../Components/BreadcrumbHead/BreadcrumbHead";
// Assets import
import logo from "../../../assets/CCAlogo.webp";
import logo1 from "../../../assets/firstpasslogo.webp";
import logo2 from "../../../assets/hicurelogoblack.webp";
import logo3 from "../../../assets/petlogo.webp";
import logo4 from "../../../assets/kitchenaralogo.webp";
import logo5 from "../../../assets/Bizfilogo.webp";
import logo6 from "../../../assets/splash-logo.webp";
import logo7 from "../../../assets/builtoplogoblack.webp";


import cca from "../../../assets/cca-mobileapp.webp";
import Travelet from "../../../assets/Travel.webp";
import Tamwil from "../../../assets/Tamwil.webp";
import bizifi from "../../../assets/bizfi.webp";
import HiCure from "../../../assets/HiCure.webp";
import Dukan from "../../../assets/Dukan.webp";
import NoSugar from "../../../assets/NoSugar.webp";
import Pet from "../../../assets/PetOasis.webp";
import kitchenara from "../../../assets/kitchenara.webp";
import firstpassweb from "../../../assets/firstpassweb.webp";
import Yusra3 from "../../../assets/Yusra3.webp";
import BuiltopMobile from "../../../assets/BuiltopMobileApp.webp";
import Superloyall from "../../../assets/superloyal.webp";


function CaseStudyCardDetail({ data,onClick }) {
    return (
      <div
        className={`container portfolio-card`}
      >
        <div className="row col-lg-12 col-md-12 col-sm-12 col-12">
          <div className="col-lg-5 col-md-5 col-sm-12 col-12 head-img">
            <img src={data.Image} alt="Service Banner" />
          </div>
          <div className="col-lg-7 col-md-7 col-sm-12 col-12 portfolio-detail">
          <h3>{data.title}</h3>
          <p>{data.detail}</p>
          <p>{data.detail2}</p>
          <p>{data.detail3}</p>
          <button
           onClick={onClick}
            type="submit"
            className="portfolio-btn"
            style={{ backgroundColor: "#04153A", color: "white" }}
          >
            Case Study
          </button>

          </div>
        </div>
      </div>
    );
  }
  

function Portfolio () {
  const navigate = useNavigate();
  const caseStudies = [
    {
      title: "Cross Culture Asia",
      detail:
        "The leading global association for overseas Asian women, fostering connections, promoting cultural heritage, and supporting community businesses.",
        link: "",
      Image: cca,
    },
    {
      title: "Dukandar Online",
      detail:
      "A transformative platform providing SMEs with comprehensive digital tools, including automated inventory, online POS, and data analytics to drive business growth.  ",
      link: "",
      Image: Dukan,
    },
    {
      title: "Yusra",
      detail:
        "A comprehensive website delivering a range of services or products, prioritizing high quality and exceptional customer satisfaction in its industry.",
        link: "",
      Image: Yusra3,
    },
    {
      title: "NoSugar",
      detail:
        "A trailblazer in sugar-free products, delivering keto bars and other treats made with high-quality ingredients and no added sugars or fillers. ",
        link: "",
      Image: NoSugar,
    },
    {
      title:"Kitchenara",
      detail:"A culinary website providing recipes, cooking tips, and kitchen tools, aimed at enhancing the cooking experience and inspiring creativity in the kitchen.",
      link: "",
      Image:kitchenara
    },
    {
      title:"Travallet",
      detail:"An advanced multi-currency digital wallet that streamlines global transactions, offering users seamless access to local markets during their travels. ",
      link: "",
      Image:Travelet
    },
    {
      title:"TAMWWIL",
      detail:"The pioneering Algerian platform for simplifying the search for top-tier financing, offering a secure and efficient process for both individuals and businesses.",
      link: "",
      Image:Tamwil
    },
    {
      title:"HiCURE",
      detail:"Appointment Management Portal for Hijama patients, that also keep patients history and let their doctor and themselves to upload reports",
      link: "",
      Image:HiCure
    },
    {
      title:"PetOasis",
      detail:"A dedicated platform for pet care, offering an extensive selection of products and services to enhance the well-being and happiness of pets.",
      link: "",
      Image:Pet
    },
    {
      title:"Builtop",
      detail:"An all-in-one solution for construction and building management, offering tools and resources to ensure effective project planning and successful execution.",
      link: "",
      Image:BuiltopMobile
    },
    {
      title:"SuperLoyal",
      detail:" A sophisticated loyalty program platform that helps businesses engage customers through personalized rewards and tailored promotional offers.",
      link: "",
      Image:Superloyall
    },
    {
      title:"BizFi",
      detail:"A dynamic fintech company revolutionizing the lending industry with innovative solutions designed to simplify and modernize the borrowing process.",
      link: "",
      Image:bizifi
    },
    {
      title:"FirstPass-AI",
      detail:"A cutting-edge AI platform designed to streamline the tech hiring process, focusing on efficiency and innovation to improve recruitment practices.",
      link: "",
      Image:firstpassweb
    },
  ];
  const partnerLogos = [logo,logo1, logo2, logo3,logo4,logo5,logo6,logo7];
  return (
    <>
      <Navbar />
      <BreadcrumbHead title={"Portfolio"}/>
      <div className="container portfolio-sec">
      <div className="col-12 portfolio-head" >
          <h3 className="sec-heading">Project Spotlight</h3>
          <div className="col-lg-9 col-md-9 col-sm-10 col-12 logo-container">
          {partnerLogos.map((logo, index) => (
            <img
              key={index}
              src={logo}
              alt={`Partner Logo ${index + 1}`}
              className="partner-logo"
            />
          ))}
        </div>
        </div>
        <div className="col-12 portfolio-head" >
          <h3 className="sec-heading">Journey Through Our Success Stories</h3>
          <p className="sec-text">
          Explore our exceptional portfolio to witness our transformative work in action, encompassing groundbreaking web and mobile applications, bespoke software development, and captivating digital experiences that push the boundaries of technology and drive business success.
          </p>
        </div>
        <div
          className="row gap-5 mb-5"
          style={{
            display: "flex",
            marginTop: "20px",
          }}
        >
          {caseStudies.map((study, index) => (
            <CaseStudyCardDetail key={index} data={study} onClick={() => navigate(study.link)}/>
          ))}
        </div>
      </div>
     <Partner/>
     <Footprint/>
      <Footer />
    </>
  );
}

export default Portfolio;
